<app-navigator [navigator]="navigator"></app-navigator>
<br>
<ng-container *ngIf="currentUser; else waiting">
    <div class="row">
        <div [ngClass]="{'col' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <div *ngIf="userInfo?.dms_user_id!=currentUser?.user_id && userInfo?.role != 'U'" class="row align-items-center">
                <div class="col-10">
                    <span style="margin-right: 10rem;" class="roboSubTitle">{{'users.editor.alertUser' | translate}}: {{currentUser.denominazione}} | {{'users.personal.piva' | translate}}: {{currentUser.partita_iva}}</span>
                </div>
                <!--<div class="col-2 text-right">
                    <button *ngIf="userInfo?.role != 'U'" type="button" class="btn" style="margin-right: 20px;" [routerLink]="['../users']">{{ 'general.changeUser' | translate }}</button>
                </div>-->
            </div>
            <ng-container *ngIf="userInfo!.dms_user_id==currentUser!.user_id">
                <div style="float: left;">
                    <label style="margin-right: 10rem;" class="roboSubTitle">{{'users.editor.company' | translate}}: {{currentUser.denominazione}} | {{'users.personal.piva' | translate}}: {{currentUser.partita_iva}}</label>
                </div>
                <!--<div style="float: right;">
                    <button *ngIf="userInfo?.role != 'U'" type="button" class="btn" style="margin-right: 20px;" [routerLink]="['../users']">{{ 'general.changeUser' | translate }}</button>
                </div>-->
            </ng-container>
         


        </div>
    </div>
    <app-loading *ngIf="loading"></app-loading>
    <div class="inside" *ngIf="!loading">
        <div class="row">
            <div class="content">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link active" id="active-tab" data-bs-toggle="tab" data-bs-target="#active" type="button" role="tab" 
                            aria-controls="ATTIVE" aria-selected="true">{{'invoices.active' | translate}}</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="estere-tab" data-bs-toggle="tab" data-bs-target="#estere" type="button" role="tab" 
                            aria-controls="ESTERE" aria-selected="false" (click)="loadEstere()">{{'invoices.estere' | translate}}</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="passive-tab" data-bs-toggle="tab" data-bs-target="#passive" type="button" role="tab" 
                            aria-controls="PASSIVE" aria-selected="false" (click)="loadPassive()">{{'invoices.passive' | translate}}</button>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="currentUser!.email=='info@ar4mdigital.it'">
                      <button class="nav-link" id="nso-tab" data-bs-toggle="tab" data-bs-target="#nso" type="button" role="tab" 
                            aria-controls="NSO" aria-selected="false" (click)="loadNso()">NSO</button>
                    </li>
                </ul>
                <div class="tab-content" id="myTabContent" [ngClass]="{'col' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
                    <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
                        <div class="row">
                            <div class="form-group col actions">
                                <div class="row">
                                    
                                    <div style="float: left;">

                                        <button type="button" *ngIf="currentUser.abilitato!=0" class="btn btn-light" style="margin-right: 12px;" [routerLink]="['new']" [ngbTooltip]="'invoices.addInvoice.new' | translate"><i class="bi bi-plus-circle"></i> {{ 'invoices.button.new' | translate }}</button>
                                        
                                        <button type="button" class="btn btn-light" style="margin-right: 12px;" (click)="importFile.click();"><i class="bi bi-upload"></i> {{ 'invoices.button.uploadFromAndSend' | translate }}</button>
                                        <button type="button" class="btn btn-light" (click)="importConserva.click();"><i class="bi bi-cloud-upload"></i> {{ 'invoices.button.chargeInStorage' | translate }}</button>
                                        <!--<div ngbDropdown class="btn buttonMenu">
                                            <button class="btn btn-warning" id="dropdownBasic1" ngbDropdownToggle>
                                                <i class="bi bi-cloud-upload"></i> {{ 'invoices.button.chargeInStorage' | translate }}
                                            </button>
                                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="padding: 0.5rem; width: 90%;">
                                                <div style="padding: 0.5rem;" (click)="importConserva.click();">
                                                    <img  src="assets/icone_varie/file.svg" style="width: 1.25rem; margin-right: 1rem;">Fatture
                                                </div>
                                                <div style="padding: 0.5rem;" (click)="importNotifica.click();">
                                                    <img  src="assets/icone_varie/notifica.svg" style="width: 1.25rem; margin-right: 1rem;">Notifiche
                                                </div>
                                            </div>
                                        </div>-->
                                        
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <app-active-invoices [userInfo]="currentUser" [structureDocType]="structureDocType" [structureWorkflowStates]="structureWorkflowStates"></app-active-invoices>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="passive" role="tabpanel" aria-labelledby="passive-tab">
                        <!-- <app-view-invoices [currentUser]="currentUser"></app-view-invoices> -->
                        <div class="row">
                            <div class="form-group col actions">
                                <div class="row">
                                   
                                        <div style="float: right;">
                                        <button type="button" class="btn btn-light" style="margin-right: 20px;" (click)="importPConserva.click()">
                                            <i class="bi bi-cloud-upload"></i> {{ 'invoices.button.uploadInvoiceInStorage' | translate }} </button>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <ng-container *ngIf="!caricamentoPassive else passive">
                                <app-loading></app-loading>
                            </ng-container>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="estere" role="tabpanel" aria-labelledby="estere-tab">
                        <!-- <app-view-invoices [currentUser]="currentUser"></app-view-invoices> -->
                        <div class="row">
                            <div class="form-group col actions">
                                <div class="row">
                                    
                                    <!--<div style="float: right;">
                                        <button type="button" class="btn btn-light" style="margin-right: 20px;" (click)="importPConserva.click()">
                                            <i class="bi bi-cloud-upload"></i> {{ 'invoices.button.uploadInvoiceInStorage' | translate }} </button>
                                    </div>-->
                                </div>
                            </div>
                            <hr>
                            <ng-container *ngIf="!caricamentoEstere else estere">
                                <app-loading></app-loading>
                            </ng-container>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="nso" role="tabpanel" aria-labelledby="nso-tab" *ngIf="currentUser!.email=='info@ar4mdigital.it'">
                        <div class="row">
                            <div class="form-group col actions">
                                <div class="row">
                                    <div style="float: right;"></div>
                                </div>
                            </div>
                            <hr>
                            <ng-container *ngIf="!caricamentoNSO else nso">
                                <app-loading></app-loading>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<input type="file" name="my_file" #importFile style="visibility: hidden;" (change)="loadFile($event)">
<input type="file" name="my_file" #importConserva style="visibility: hidden;" (change)="loadInvoiceInConserva($event)">
<input type="file" name="my_file" #importPConserva style="visibility: hidden;" (change)="loadPInvoiceInConserva($event)">


<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>

<ng-template #estere>
    <app-estere-invoices #estereInvoices [userInfo]="currentUser" [structureDocType]="structureDocType" [structureWorkflowStates]="structureWorkflowStates"></app-estere-invoices>
</ng-template>

<ng-template #passive>
    <app-passive-invoices #passiveInvoices [userInfo]="currentUser"></app-passive-invoices>
</ng-template>

<ng-template #nso>
    <app-nso-invoices #nsoInvoices [userInfo]="currentUser"></app-nso-invoices>
</ng-template>
